{
    "UsersByExtensions_ModalTitle": "Users",
    "UsersByExtensions_Filters": "Filters",
    "UsersByExtensions_AllPartitions": "All Sites",
    "UsersByExtensions_AllSecGroups": "[All]",
    "UsersByExtensions_Header_Users": "Extension - Full Name",
    "UsersByExtensions_Header_MS_Licences": "MS Licences",
    "UsersByExtensions_UserFields_Email": "Email",
    "UsersByExtensions_UserFields_Welcome_Mail": "Send welcome email",
    "UsersByExtensions_UserFields_Type": "CXA Subscription",
    "UsersByExtensions_CXS_Subscription_Header": "CXS Subscription",
    "UsersByExtensions_UserFields_CX_Integration": "CX Integration",
    "UsersByExtensions_UserFields_UseEmailAsUser": "Use Email as Username",
    "UsersByExtensions_Username_Display_Title": "Username",
    "UsersByExtensions_Username_Display_Title_No_Username": "No Username\n(You can't create this user)",
    "UsersByExtensions_UserFields_LegacyAppend": "{} (Legacy)",
    "UsersByExtensions_UserType_Legacy_Akixi Lite": "Lite",
    "UsersByExtensions_UserType_Legacy_Akixi ONE": "ONE",
    "UsersByExtensions_UserType_Legacy_Akixi BLF": "Presence",
    "UsersByExtensions_UserType_Legacy_Akixi 1000": "1000",
    "UsersByExtensions_UserType_Legacy_Akixi 2000": "2000",
    "UsersByExtensions_UserFields_Checkbox_Tooltip": "Create/Update User",
    "UsersByExtensions_UserFields_Cross_Tooltip": "Delete User",
    "UsersByExtension_UserType_NONE": "Monitoring Deactivated (Unlicensed)",
    "UsersByExtension_UserType_ESSENTIALS": "Essentials",
    "UsersByExtension_UserType_ESSENTIALS_WxC": "WxC User",
    "UsersByExtension_UserType_ESSENTIALS_MST": "CXA Standard",
    "UsersByExtension_UserType_PROFESSIONAL": "Professional",
    "UsersByExtension_UserType_PROFESSIONAL_MST": "CXA Premium",
    "UsersByExtension_UserType_ENTERPRISE": "Enterprise",
    "UsersByExtension_UserType_ENTERPRISE_MST": "CXA Advanced (Historic)",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT": "Call Center Agent",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT_WxC": "WxC Agent",
    "UsersByExtension_UserType_CALL_CENTRE_AGENT_MST": "CXA Premium",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR": "Call Center Supervisor",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR_WxC": "WxC Supervisor",
    "UsersByExtension_UserType_CALL_CENTRE_SUPERVISOR_MST": "CXA Advanced",
    "UsersByExtension_CxiLicenceType_SOLO": "Solo",
    "UsersByExtension_CxiLicenceType_TEAMS": "Teams",
    "UsersByExtension_CxiLicenceType_CX_INTEGRATION": "CX Integration",
    "UsersByExtension_CxiLicenceType_NONE": "None",
    "UsersByExtension_UserType_IsNotAgent": "This user has an Agent if you give them this Subscription then Agent activity will no longer be monitored",
    "UsersByExtension_UserType_IsNone": "This users associated Extension will no longer be monitored if you give them this subscription",
    "UsersByExtension_Users_Multiple_Errors": "There are multiple users assigned to this extension: {}",
    "UsersByExtensions_ConfirmUserDelete": "Click again to confirm you want to remove reporting access?",
    "UserByExtension_LicenceTypes_EV": "EV License",
    "UserByExtension_LicenceTypes_None": "Teams User",
    "LicenceSummary_Title": "License Summary",
    "LicenceSummary_Headers_Type": "Type",
    "LicenceSummary_Headers_InUse": "In Use",
    "LicenceSummary_Types_Essentials": "Essentials",
    "LicenceSummary_Types_Essentials_MST": "CXA Standard",
    "LicenceSummary_Types_Professional": "Professional",
    "LicenceSummary_Types_Professional_MST": "CXA Premium",
    "LicenceSummary_Types_Enterprise": "Enterprise",
    "LicenceSummary_Types_Enterprise_MST": "CXA Advanced (Historic)",
    "LicenceSummary_Types_CallCentreAgent": "Call Centre Agent",
    "LicenceSummary_Types_CallCentreAgent_MST": "CXA Premium",
    "LicenceSummary_Types_CallCentreSupervisor": "Call Centre Supervisor",
    "LicenceSummary_Types_CallCentreSupervisor_MST": "CXA Advanced",
    "LicenceSummary_Types_CXIntegration": "CX Integration",
    "LicenceSummary_Types_Unlicenced": "Unlicensed",
    "AddAllUsers_Button_Title": "Create users for all unmonitored extensions",
    "AddAllUsers_Button_Title_Interpolated": "Create {} users for all unmonitored extensions",
    "AddAllUsers_Send_Welcome_Email_Checkbox_Text": "Please untick if you **do not** want to send a welcome email to all users.",
    "ProvisionAllCxi_Button_Title_Interpolated": "Create/update users with {}",
    "ProvisionAllCxi_PromptMessage": "Create users for all unmonitored extensions with \"{}\".\n\nAll unsaved changes will be lost, are you sure you want to continue?\n\n",
    "AddAllUsers_PromptMessage": "Create users for all unmonitored extensions with \"{}\" license.\n\nAll unsaved changes will be lost, are you sure you want to continue?\n\n",
    "AddAllUsers_Confirm": "Confirm",
    "AddAllUsers_Cancel": "Cancel",
    "AddAllUsers_CreatingUsers": "Adding {} users with \"{}\" license...",
    "AddAllUsers_Loading": "Loading...",
    "NoUsersAdded": "No users were added",
    "TooManyUsers_NoLicences": "Cannot add {} user as no licenses are available",
    "TooManyUsers_MaxTelSysCapReached": "Cannot add {} user as it would exceed the maximum number of users allowed by the telephone system",
    "TooManyUsers_MaxTelSysCapReached_Plural": "Cannot add {} users as it would exceed the maximum number of users allowed by the telephone system",
    "TooManyUsers_UsersPlural_LicenceNonPlural": "Cannot add {} users as only {} license is available",
    "TooManyUsers_UsersNonPlural_LicenceNonPlural": "Cannot add {} user as only {} license is available",
    "TooManyUsers_NoLicences_Plural": "Cannot add {} users as no licenses are available",
    "TooManyUsers": "Cannot add {} user as only {} licenses are available",
    "TooManyUsers_Plural": "Cannot add {} users as only {} licenses are available",
    "SuccessfullyAddedUsers": "Licenced {} users with \"{}\" license successfully",
    "SendWelcomeEmailTitle": "Resend welcome email to \"{}\"",
    "SendWelcomeEmailConfirm": "Would you like to resend the welcome email to \"{}\"?",
    "EmailSuccessMessage": "Email was successfully sent to \"{}\"",
    "EmailFailMessage": "There was an unexpected error when sending the email. Please try again.",
    "Telsys_MissingRoles_Day0": "Degraded Provisioning. Please enable User Admin Permission against the TelSys Auth User.",
    "Telsys_MissingRoles_Day1": "User Admin Permission not found against the TelSys Auth User. Proceed with Caution.",
    "NAME": "UsersByExtension"
}
